import React from 'react';
import styles from './PlanHeadingSection.module.scss';
interface Props {
  Heading: string;
  Description: string;
  OptionsListHeading: string;
}
const PlanHeadingSection = ({
  Heading,
  Description,
  OptionsListHeading,
}: Props) => {
  return (
    <>
      <div className="Changepaymentplan-textBox Grid-cell u-lg-size1of1">
        <h1
          className={
            'Heading Changepaymentplan-pageHeading ' + styles.changepageHeading
          }
        >
          {Heading}
        </h1>
        <p className="Changepaymentplan-intro">{Description}</p>
        <p className="Changepaymentplan-introLabel">{OptionsListHeading}</p>
      </div>
    </>
  );
};
export default PlanHeadingSection;
